import { createApp, h, configureCompat } from 'vue';
import Password from './registration/password-component.vue';
import i18n from './registration/i18n';
import './registration/registration.scss';

(function () {
  const rootElement = document.getElementById('registration-password');
  const passwordError = rootElement.getAttribute('passwordError');
  const passwordConfirmationError = rootElement.getAttribute(
    'passwordConfirmationError',
  );

  document.addEventListener('DOMContentLoaded', () => {
    const app = createApp({
      render: () =>
        h(Password, {
          passwordError,
          passwordConfirmationError,
        }),
    });
    app.use(i18n);

    app.mount('#registration-password');
  });
}).call(this);

configureCompat({
  MODE: 3,
});

if (global.jQuery === undefined) {
  global.$ = require('jquery');
  global.jQuery = $;
}

$(document).ready(function () {
  $('.locale-link-dropdown li a').on('click', function (event) {
    return setLocationWithParams(this.href);
  });

  return $('#new_registration_form').submit(function () {
    if (typeof ga !== 'undefined') {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Account',
        eventAction: 'SignUp',
        eventLabel: 'Completed',
      });
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {
        send_to: 'AW-627229799/nuy2CLqlv9IBEOeIi6sC',
        transaction_id: '',
      });
    }
    if (typeof ytag !== 'undefined') {
      ytag({
        type: 'yss_conversion',
        config: {
          yahoo_conversion_id: '1001130856',
          yahoo_conversion_label: '1414CPHpvOsBELDNrKkC',
          yahoo_conversion_value: '0',
        },
      });
    }
  });
});

var setLocationWithParams = function (href) {
  if (typeof URLSearchParams === 'undefined') {
    return;
  }

  event.preventDefault();

  const storeName = $('#registration_form_store_name').val();
  const name = $('#registration_form_name').val();
  const email = $('#registration_form_email').val();

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('store_name', storeName);
  searchParams.set('name', name);
  searchParams.set('email', email);

  const url = new URL(href);
  url.search = searchParams;
  return (window.location = url.href);
};
